import { Component, Input, OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { AuthService } from '../../auth/auth/auth.service';


@Component({
  selector: 'app-travel-affiliations',
  templateUrl: './travel-affiliations.component.html',
  styleUrls: ['./travel-affiliations.component.scss']
})
export class TravelAffiliationsComponent implements OnInit {
  @Input() airport: Airport;

  constructor(private _auth: AuthService) { }

  ngOnInit() {
  }

  isAuthenticated(): boolean {
    return (this._auth.authenticated && this._auth.endUser);
  }

  redirectToLogin() {
    this._auth.redirectToLogin();
  }
}
